export const products = [
  // --- VEG Momo's'S CATEGORY ---
  {
    "id": "VEG-MOM-001",
    "title": "Veg Momo's Steam",
    "description": "Steamed dumplings filled with fresh vegetables and a blend of spices.",
    "image": "https://i.ibb.co/KTgVxJv/MOMO-001.jpg",
    "tags": ["Veg", "Momo's", "Steamed"],
    "category": "Momo's",
    "options": [
      { "name": "Half", "price": 30 },
      { "name": "Full", "price": 55 }
    ]
  },
  {
    "id": "VEG-MOM-002",
    "title": "Veg Momo's Fry",
    "description": "Crispy fried dumplings with a savory vegetable filling.",
    "image": "https://i.ibb.co/yFsjcYMS/MOM-002.jpg",
    "tags": ["Veg", "Momo's", "Fried"],
    "category": "Momo's",
    "options": [
      { "name": "Half", "price": 40 },
      { "name": "Full", "price": 75 }
    ]
  },
  // --- NON-VEG Momo's'S CATEGORY ---
  {
    "id": "NON-VEG-MOM-001",
    "title": "Chicken Momo's Steam",
    "description": "Steamed dumplings filled with seasoned minced chicken.",
    "image": "https://i.ibb.co/RpvbG8dV/MOM-003.jpg",
    "tags": ["Non-Veg", "Chicken", "Momo's", "Steamed"],
    "category": "Momo's",
    "options": [
      { "name": "Half", "price": 45 },
      { "name": "Full", "price": 85 }
    ]
  },
  {
    "id": "NON-VEG-MOM-002",
    "title": "Chicken Momo's Fry",
    "description": "Crispy fried dumplings filled with delicious minced chicken.",
    "image": "https://i.ibb.co/LhrjYPXY/MOM-004.jpg",
    "tags": ["Non-Veg", "Chicken", "Momo's", "Fried"],
    "category": "Momo's",
    "options": [
      { "name": "Half", "price": 50 },
      { "name": "Full", "price": 95 }
    ]
  },
  // --- VEG CHAWMEIN'S CATEGORY ---
  {
    "id": "VEG-CHW-001",
    "title": "Veg Chowmein",
    "description": "Stir-fried noodles with a medley of fresh vegetables and savory sauces.",
    "image": "https://i.ibb.co/k2DzR3jJ/CM-001.jpg",
    "tags": ["Veg", "Chowmein", "Noodle's"],
    "category": "Noodle's",
    "options": [
      { "name": "Half", "price": 40 },
      { "name": "Full", "price": 60 }
    ]
  },
  {
    "id": "VEG-CHW-002",
    "title": "Paneer Chowmein",
    "description": "Noodle's stir-fried with juicy paneer cubes, crisp vegetables, and special spices.",
    "image": "https://i.ibb.co/q3ZCLkXY/CM-002.jpg",
    "tags": ["Veg", "Paneer", "Chowmein", "Noodle's"],
    "category": "Noodle's",
    "options": [
      { "name": "Half", "price": 60 }
    ]
  },
  // --- VEG MAGGIE'S CATEGORY ---
  {
    "id": "MAG-001",
    "title": "Veg Maggie",
    "description": "Classic Maggie noodles cooked with fresh vegetables for a wholesome meal.",
    "image": "https://i.ibb.co/H8sv8d8/CM-003.jpg",
    "tags": ["Veg", "Maggie", "Noodle's"],
    "category": "Noodle's",
    "options": [
      { "name": "Half", "price": 30 },
      { "name": "Full", "price": 55 }
    ]
  },
  {
    "id": "MAG-002",
    "title": "Veg Cheez Maggie",
    "description": "Delicious Maggie noodles with vegetables and a generous topping of melted cheese.",
    "image": "https://i.ibb.co/v6SfLYZJ/CM-004.jpg",
    "tags": ["Veg", "Cheese", "Maggie", "Noodle's"],
    "category": "Noodle's",
    "options": [
      { "name": "Half", "price": 40 },
      { "name": "Full", "price": 75 }
    ]
  },
  {
    "id": "MAG-003",
    "title": "Paneer Maggie",
    "description": "Maggie noodles enriched with succulent cubes of paneer.",
    "image": "https://i.ibb.co/PvjThC0R/CM-005.jpg",
    "tags": ["Veg", "Paneer", "Maggie", "Noodle's"],
    "category": "Noodle's",
    "options": [
      { "name": "Half", "price": 45 },
      { "name": "Full", "price": 85 }
    ]
  },
  {
    "id": "MAG-004",
    "title": "Paneer Cheez Maggie",
    "description": "A delightful combination of Maggie, paneer, and a rich layer of melted cheese.",
    "image": "https://i.ibb.co/JF0PTNL9/CM-006.jpg",
    "tags": ["Veg", "Paneer", "Cheese", "Maggie", "Noodle's"],
    "category": "Noodle's",
    "options": [
      { "name": "Half", "price": 50 },
      { "name": "Full", "price": 90 }
    ]
  },
  // --- NON-VEG CHAWMEIN'S CATEGORY ---
  {
    "id": "NON-VEG-CHW-001",
    "title": "Chicken Chowmein",
    "description": "Stir-fried noodles with savory chicken pieces and fresh vegetables.",
    "image": "https://i.ibb.co/Xf1fL0tN/CM-007.jpg",
    "tags": ["Non-Veg", "Chicken", "Chowmein", "Noodle's"],
    "category": "Noodle's",
    "price": 60
  },

  // --- VEG SANDWICH'S CATEGORY ---
  {
    "id": "VEG-SAND-001",
    "title": "Veg Sandwich's",
    "description": "A classic grilled sandwich with fresh vegetables and a zesty spread.",
    "image": "https://i.ibb.co/JjsKVVbR/SB-001.jpg",
    "tags": ["Veg", "Sandwich's"],
    "category": "Sandwich & Burger",
    "price": 40
  },
  {
    "id": "VEG-SAND-002",
    "title": "Veg Cheez Sandwich's",
    "description": "A grilled vegetable sandwich with a generous layer of gooey melted cheese.",
    "image": "https://i.ibb.co/ccZ4qFm9/SB-002.jpg",
    "tags": ["Veg", "Cheese", "Sandwich's"],
    "category": "Sandwich & Burger",
    "price": 50
  },
  {
    "id": "VEG-SAND-003",
    "title": "Paneer Sandwich's",
    "description": "A delicious sandwich filled with spiced paneer cubes and fresh veggies.",
    "image": "https://i.ibb.co/gZVrJpcJ/SB-003.jpg",
    "tags": ["Veg", "Paneer", "Sandwich's"],
    "category": "Sandwich & Burger",
    "price": 50
  },
  {
    "id": "VEG-SAND-004",
    "title": "Paneer Cheez Sandwich's",
    "description": "The perfect combination of paneer and cheese in a grilled sandwich.",
    "image": "https://i.ibb.co/p6qf7Vvj/SB-004.jpg",
    "tags": ["Veg", "Paneer", "Cheese", "Sandwich's"],
    "category": "Sandwich & Burger",
    "price": 60
  },
  // --- VEG BURGER'S CATEGORY ---
  {
    "id": "VEG-BUR-001",
    "title": "Veg Burger",
    "description": "A classic burger with a vegetable patty, fresh lettuce, and our special sauce.",
    "image": "https://i.ibb.co/mrtn9PhJ/SB-005.jpg",
    "tags": ["Veg", "Burger"],
    "category": "Sandwich & Burger",
    "price": 30
  },
  {
    "id": "VEG-BUR-002",
    "title": "Veg Cheez Burger",
    "description": "A vegetable patty burger with a slice of melted cheese.",
    "image": "https://i.ibb.co/ZPGKdyM/SB-006.jpg",
    "tags": ["Veg", "Cheese", "Burger"],
    "category": "Sandwich & Burger",
    "price": 40
  },
  {
    "id": "VEG-BUR-003",
    "title": "Paneer Burger",
    "description": "A delicious burger with a paneer patty and flavorful seasonings.",
    "image": "https://i.ibb.co/6LkDnrq/SB-007.jpg",
    "tags": ["Veg", "Paneer", "Burger"],
    "category": "Sandwich & Burger",
    "price": 50
  },
  {
    "id": "VEG-BUR-004",
    "title": "Paneer Cheez Burger",
    "description": "A paneer burger with a slice of melted cheese for extra richness.",
    "image": "https://i.ibb.co/PZRzxVp6/SB-008.jpg",
    "tags": ["Veg", "Paneer", "Cheese", "Burger"],
    "category": "Sandwich & Burger",
    "price": 50
  },
  // --- NON-VEG BURGER'S CATEGORY ---
  {
    "id": "NON-VEG-BUR-001",
    "title": "Chicken Burger",
    "description": "A classic burger with a juicy chicken patty.",
    "image": "https://i.ibb.co/tjtrzMq/SB-009.jpg",
    "tags": ["Non-Veg", "Chicken", "Burger"],
    "category": "Sandwich & Burger",
    "price": 50
  },
  {
    "id": "NON-VEG-BUR-002",
    "title": "Chicken Cheez Burger",
    "description": "A chicken burger with a slice of melted cheese on top.",
    "image": "https://i.ibb.co/x8B0SsY6/SB-010.jpg",
    "tags": ["Non-Veg", "Chicken", "Cheese", "Burger"],
    "category": "Sandwich & Burger",
    "price": 60
  },

  
  // --- Chilli's'S CATEGORY ---
  {
    "id": "Chilli's-001",
    "title": "Paneer Chilli Dry",
    "description": "Cubes of paneer stir-fried with onions, bell peppers, and a spicy chili sauce.",
    "image": "https://i.ibb.co/tww7Ps9r/C-001.jpg",
    "tags": ["Veg", "Paneer", "Chilli's", "Dry"],
    "category": "Chilli's",
    "options": [
      { "name": "Half", "price": 70 },
      { "name": "Full", "price": 130 }
    ]
  },
  {
    "id": "Chilli's-002",
    "title": "Paneer Chilli Gravy",
    "description": "Tender paneer cubes cooked in a thick and spicy chili-based gravy.",
    "image": "https://i.ibb.co/prv6XfhC/C-002.jpg",
    "tags": ["Veg", "Paneer", "Chilli's", "Gravy"],
    "category": "Chilli's",
    "options": [
      { "name": "Half", "price": 80 },
      { "name": "Full", "price": 150 }
    ]
  },
   // --- NON-VEG Chilli's'S CATEGORY ---
  {
    "id": "NON-VEG-Chilli's-001",
    "title": "Chicken Chilli Dry",
    "description": "Stir-fried chicken pieces with onions and bell peppers in a spicy chili sauce.",
    "image": "https://i.ibb.co/S4QHgJVG/C-004.jpg",
    "tags": ["Non-Veg", "Chicken", "Chilli's", "Dry"],
    "category": "Chilli's",
    "options": [
      { "name": "Half", "price": 80 },
      { "name": "Full", "price": 150 }
    ]
  },
  {
    "id": "NON-VEG-Chilli's-002",
    "title": "Chicken Chilli Gravy",
    "description": "Chicken pieces cooked in a rich and spicy gravy.",
    "image": "https://i.ibb.co/9H22mMkD/C-003.jpg",
    "tags": ["Non-Veg", "Chicken", "Chilli's", "Gravy"],
    "category": "Chilli's",
    "options": [
      { "name": "Half", "price": 90 },
      { "name": "Full", "price": 170 }
    ]
  },

  // --- VEG FRY RICE'S CATEGORY ---
  {
    "id": "VEG-FRY-RICE-001",
    "title": "Veg Fry Rice's",
    "description": "Aromatic fried rice with a colorful mix of vegetables.",
    "image": "https://i.ibb.co/398csMD7/R-001.jpg",
    "tags": ["Veg", "Fried Rice's"],
    "category": "Rice's",
    "price": 50
  },
  {
    "id": "VEG-FRY-RICE-002",
    "title": "Paneer Fry Rice's",
    "description": "Fried rice with tender paneer cubes and a medley of fresh vegetables.",
    "image": "https://i.ibb.co/bgTDdcwD/R-002.jpg",
    "tags": ["Veg", "Paneer", "Fried Rice's"],
    "category": "Rice's",
    "price": 90
  },
  // --- NON-VEG FRY RICE'S CATEGORY ---
  {
    "id": "NON-VEG-FRY-RICE-001",
    "title": "Chicken Fry Rice's",
    "description": "Fried rice with tender chicken pieces and a mix of vegetables.",
    "image": "https://i.ibb.co/tTPzwqBz/R-003.jpg",
    "tags": ["Non-Veg", "Chicken", "Fried Rice's"],
    "category": "Rice's",
    "price": 80
  },
  {
    "id": "NON-VEG-FRY-RICE-002",
    "title": "Egg Fry Rice's",
    "description": "Fried rice tossed with scrambled eggs and fresh veggies.",
    "image": "https://i.ibb.co/GQ8M2b8N/R-004.jpg",
    "tags": ["Non-Veg", "Egg", "Fried Rice's"],
    "category": "Rice's",
    "price": 70
  },
  {
    "id": "NON-VEG-FRY-RICE-003",
    "title": "Briyani Rice's",
    "description": "Fried rice tossed with scrambled eggs and fresh veggies.",
    "image": "https://i.ibb.co/KxHgBS6k/Briyani-Rice.jpg",
    "tags": ["Briyani Rice's"],
    "category": "Rice's",
    "price": 70
  },
  // --- RICE CATEGORY ---
  {
    "id": "RIC-001",
    "title": "Plain Rice's",
    "description": "Simple and perfectly cooked steamed rice, a great accompaniment to any dish.",
    "image": "https://i.ibb.co/p6NFJypv/M-002.jpg",
    "tags": ["Veg", "Rice's", "Side Dish"],
    "category": "Rice's",
    "options": [
      { "name": "Half", "price": 20 },
      { "name": "Full", "price": 40 }
    ]
  },
  
  // --- Chaat & D'Vada CATEGORY ---
  {
    "id": "Chaat & D'Vada-001",
    "title": "Papdi Chaat",
    "description": "A popular Indian street food with crispy flour crackers, potatoes, chickpeas, and a mix of chutneys and yogurt.",
    "image": "https://i.ibb.co/RTqwkjWN/CV-001.jpg",
    "tags": ["Veg", "Chaat", "Street Food"],
    "category": "Chaat & D'Vada",
    "price": 30
  },
  {
    "id": "Chaat & D'Vada-002",
    "title": "Dahi Vada",
    "description": "Soft lentil fritters soaked in yogurt and topped with sweet and spicy chutneys.",
    "image": "https://i.ibb.co/wr7QzGx8/CV-002.jpg",
    "tags": ["Veg", "Dahi", "Vada", "Street Food"],
    "category": "Chaat & D'Vada",
    "price": 30
  },
  // --- Pakoda CATEGORY ---
  {
    "id": "PAO-001",
    "title": "Paneer Papad",
    "description": "A special dish of paneer, prepared in a unique style.",
    "image": "https://i.ibb.co/4RD3CL70/PP-00.jpg",
    "tags": ["Veg", "Paneer", "Special"],
    "category": "Papad",
    "price": 60
  },

  // --- DRINK'S CATEGORY ---
  {
    "id": "DRINK-001",
    "title": "Chai",
    "description": "Classic Indian milk tea, spiced with ginger and cardamom.",
    "image": "https://i.ibb.co/TZgb8Mx/D-001.jpg",
    "tags": ["Drink", "Chai", "Tea"],
    "category": "Drinks",
    "price": 12
  },
  {
    "id": "DRINK-002",
    "title": "Coffee",
    "description": "A hot cup of freshly brewed coffee.",
    "image": "https://i.ibb.co/0pJQ4G5m/D-002.jpg",
    "tags": ["Drink", "Coffee"],
    "category": "Drinks",
    "price": 30
  },
  {
    "id": "DRINK-003",
    "title": "Kulhad Coffee",
    "description": "Coffee served in a traditional earthenware cup, giving it an earthy aroma.",
    "image": "https://i.ibb.co/vCcGXGfC/D-003.jpg",
    "tags": ["Drink", "Coffee"],
    "category": "Drinks",
    "price": 40
  },
  {
    "id": "DRINK-004",
    "title": "Cold Coffee",
    "description": "A refreshing blend of coffee, milk, and sugar, served chilled.",
    "image": "https://i.ibb.co/JjRVrh2c/D-004.jpg",
    "tags": ["Drink", "Coffee", "Cold"],
    "category": "Drinks",
    "price": 60
  },
  {
    "id": "DRINK-005",
    "title": "Mango Shake",
    "description": "A creamy and delicious milkshake made with fresh mangoes.",
    "image": "https://i.ibb.co/5hds7Qf1/D-005.jpg",
    "tags": ["Drink", "Shake", "Mango"],
    "category": "Drinks",
    "price": 60
  },
  {
    "id": "DRINK-006",
    "title": "Banana Shake",
    "description": "A thick and creamy milkshake blended with ripe bananas.",
    "image": "https://i.ibb.co/HDgbRTDk/D-006.jpg",
    "tags": ["Drink", "Shake", "Banana"],
    "category": "Drinks",
    "price": 60
  },
  {
    "id": "DRINK-007",
    "title": "Mojito",
    "description": "A refreshing drink made with mint, lime, and soda.",
    "image": "https://i.ibb.co/rGTzHnrd/D-007.jpg",
    "tags": ["Drink", "Mojito"],
    "category": "Drinks",
    "price": 40
  },

  // --- NON-VEG STICK'S CATEGORY ---
  {
    "id": "NON-VEG-STK-001",
    "title": "Chicken Stick",
    "description": "Crispy fried chicken sticks, perfect as a quick snack or starter.",
    "image": "https://i.ibb.co/xxS4Mzg/CK-001.jpg",
    "tags": ["Non-Veg", "Chicken", "Stick", "Snack"],
    "category": "Chicken Menu's",
    "price": 40
  },

  // --- NON-VEG ROASTED CATEGORY ---
  {
    "id": "NON-VEG-RST-001",
    "title": "Roasted Chicken",
    "description": "Juicy and flavorful roasted chicken, seasoned to perfection.",
    "image": "https://i.ibb.co/MDZQ1Lj1/CK-010.jpg",
    "tags": ["Non-Veg", "Chicken", "Roasted"],
    "category": "Chicken Menu's",
    "price": 150
  },
  {
    "id": "NON-VEG-RST-002",
    "title": "Grilled Chicken",
    "description": "Juicy and flavorful roasted chicken, seasoned to perfection.",
    "image": "https://i.ibb.co/5X7rvqtq/CK-002.jpg",
    "tags": ["Non-Veg", "Chicken", "Grilled"],
    "category": "Chicken Menu's",
    "options": [
      { "name": "Half", "price": 170 },
      { "name": "Full", "price": 320 }
    ]
  },

  // --- NON-VEG BIRYANI CATEGORY ---
  {
    "id": "NON-VEG-BRY-001",
    "title": "Chicken Biryani",
    "description": "A fragrant rice dish cooked with marinated chicken and aromatic spices.",
    "image": "https://i.ibb.co/Pz9qB6p1/CK-003.jpg",
    "tags": ["Non-Veg", "Chicken", "Biryani", "Rice's"],
    "category": "Chicken Menu's",
    "price": 100
  },

  // --- NON-VEG CHICKEN FRY CATEGORY ---
  {
    "id": "NON-VEG-FRY-001",
    "title": "Chicken Fry",
    "description": "Crispy deep-fried chicken pieces, a classic favorite.",
    "image": "https://i.ibb.co/jZTPRd6N/CK-004.jpg",
    "tags": ["Non-Veg", "Chicken", "Fried"],
    "category": "Chicken Menu's",
    "price": 80
  },

  // --- NON-VEG LOLLIPOP'S CATEGORY ---
  {
    "id": "NON-VEG-LOL-001",
    "title": "Chicken Lollipop Dry",
    "description": "Frenched chicken drumettes, marinated and fried until golden brown.",
    "image": "https://i.ibb.co/BHpMsFhV/CK-005.jpg",
    "tags": ["Non-Veg", "Chicken", "Lollipop", "Dry"],
    "category": "Chicken Menu's",
    "price": 120
  },
  {
    "id": "NON-VEG-LOL-002",
    "title": "Chicken Lollipop Gravy",
    "description": "Chicken lollipops tossed in a delicious and tangy gravy.",
    "image": "https://i.ibb.co/Mk17vyLs/CK-006.jpg",
    "tags": ["Non-Veg", "Chicken", "Lollipop", "Gravy"],
    "category": "Chicken Menu's",
    "price": 160
  },

  // --- NON-VEG LEG PIECE'S CATEGORY ---
  {
    "id": "NON-VEG-LEG-001",
    "title": "Chicken Leg Piece",
    "description": "A succulent fried chicken leg piece, perfect for a hearty meal.",
    "image": "https://i.ibb.co/SwVR0f22/CK-007.jpg",
    "tags": ["Non-Veg", "Chicken", "Fried"],
    "category": "Chicken Menu's",
    "price": 60
  },
  // --- NON-VEG TASHA BHUJA CATEGORY ---
  

  // --- NON-VEG TIKKA CATEGORY ---
  {
    "id": "NON-VEG-TIK-001",
    "title": "Chicken Tikka",
    "description": "Succulent boneless chicken pieces marinated in spices and grilled to perfection.",
    "image": "https://i.ibb.co/CK1x5FV0/CK-009.jpg",
    "tags": ["Non-Veg", "Chicken", "Tikka"],
    "category": "Chicken Menu's",
    "price": 45
  },

  

  

  // --- VEG ROLL'S CATEGORY ---
  {
    "id": "VEG-ROL-001",
    "title": "Veg Roll",
    "description": "A savory roll filled with stir-fried vegetables and a tangy sauce.",
    "image": "https://i.ibb.co/PvXQ4MK6/RO-001.jpg",
    "tags": ["Veg", "Roll"],
    "category": "Roll's",
    "price": 35
  },
  {
    "id": "VEG-ROL-002",
    "title": "Paneer Roll",
    "description": "A fulfilling roll stuffed with succulent paneer and mixed vegetables.",
    "image": "https://i.ibb.co/gkYRBLd/RO-002.jpg",
    "tags": ["Veg", "Paneer", "Roll"],
    "category": "Roll's",
    "price": 50
  },
  // --- NON-VEG ROLL'S CATEGORY ---
  {
    "id": "NON-VEG-ROL-003",
    "title": "Chicken Roll",
    "description": "A flaky paratha roll stuffed with seasoned chicken and vegetables.",
    "image": "https://i.ibb.co/sdBR7bs4/RO-003.jpg",
    "tags": ["Non-Veg", "Chicken", "Roll"],
    "category": "Roll's",
    "price": 40
  },
  {
    "id": "NON-VEG-ROL-004",
    "title": "Chicken Shawarma Roll",
    "description": "A flaky paratha roll stuffed with seasoned chicken and vegetables.",
    "image": "https://i.ibb.co/S4yHhkYn/RO-006.jpg",
    "tags": ["Non-Veg", "Chicken", "Roll"],
    "category": "Roll's",
    "price": 60
  },
  {
    "id": "NON-VEG-ROL-005",
    "title": "Special Chicken Shawarma Roll",
    "description": "A flaky paratha roll stuffed with seasoned chicken and vegetables.",
    "image": "https://i.ibb.co/G31vBjzm/RO-007.jpg",
    "tags": ["Non-Veg", "Chicken", "Roll"],
    "category": "Roll's",
    "price": 100
  },
  {
    "id": "NON-VEG-ROL-006",
    "title": "Single Egg Roll",
    "description": "A simple and delicious roll with a single egg filling.",
    "image": "https://i.ibb.co/XfSPmTph/RO-004.jpg",
    "tags": ["Non-Veg", "Egg", "Roll"],
    "category": "Roll's",
    "price": 30
  },
  {
    "id": "NON-VEG-ROL-007",
    "title": "Double Egg Roll",
    "description": "A hearty roll with a double egg filling, perfect for a bigger appetite.",
    "image": "https://i.ibb.co/LztB39Vf/RO-005.jpg",
    "tags": ["Non-Veg", "Egg", "Roll"],
    "category": "Roll's",
    "price": 40
  },
  
  // --- NON-VEG MUTTON CATEGORY ---
  {
    "id": "NON-VEG-MUT-001",
    "title": "Mutton Gravy",
    "description": "Tender pieces of mutton cooked in a rich, flavorful gravy.",
    "image": "https://i.ibb.co/TDrsCvc9/M-001.jpg",
    "tags": ["Non-Veg", "Mutton", "Gravy"],
    "category": "Mutton Menu's",
    "price": 60
  },
  {
    "id": "NON-VEG-TASHA-001",
    "title": "Tasha Bhuja",
    "description": "A traditional dish of spiced meat, prepared with a unique blend of spices.",
    "image": "https://i.ibb.co/ZRJ2Nt7F/CK-008.jpg",
    "tags": ["Non-Veg", "Tasha Bhuja", "Mutton"],
    "category": "Mutton Menu's",
    "price": 80
  },

  // --- LITTI CATEGORY ---
  {
    "id": "LIT-001",
    "title": "Litti",
    "description": "A traditional dish of roasted wheat balls, served with chokha and chutney.",
    "image": "https://i.ibb.co/mwXf35s/M-003.jpg",
    "tags": ["Veg", "Litti", "Traditional"],
    "category": "Mutton Menu's",
    "price": 10
  },
  // --- NON-VEG OMLET CATEGORY ---
  {
    "id": "NON-VEG-OMLET-001",
    "title": "Single Egg Omlet",
    "description": "A simple and fluffy omelet made with a single egg.",
    "image": "https://i.ibb.co/20C6QQgV/E-001.jpg",
    "tags": ["Non-Veg", "Egg", "Omlet"],
    "category": "Egg Menu's",
    "price": 20
  },
  {
    "id": "NON-VEG-OMLET-002",
    "title": "Double Egg Omlet",
    "description": "A larger omelet made with two eggs, perfect for a heavier meal.",
    "image": "https://i.ibb.co/DPdsxcyH/E-002.jpg",
    "tags": ["Non-Veg", "Egg", "Omlet"],
    "category": "Egg Menu's",
    "price": 30
  },
  {
    "id": "NON-VEG-OMLET-003",
    "title": "Bread Omlet",
    "description": "An omelet served with a slice of toasted bread.",
    "image": "https://i.ibb.co/0pqB2RQ5/E-003.jpg",
    "tags": ["Non-Veg", "Egg", "Omlet", "Bread"],
    "category": "Egg Menu's",
    "price": 45
  },
 
];
// Note: The above code is a sample of a product catalog for a food delivery application.